// ============================================
// OPÇÕES DA AVALIAÇÃO DO DOADOR — fonte única (B351, AI_152)
// ============================================
// A aba de Avaliação do Doador e o catálogo da aba Pesquisa precisam falar
// EXATAMENTE a mesma língua: o que a aba grava é o que a Pesquisa filtra. Se as
// duas listas fossem escritas separadamente, bastaria mudar uma vírgula num rótulo
// para o filtro parar de encontrar os pacientes — e em silêncio, sem erro nenhum.
// Por isso as listas vivem aqui e são importadas pelos dois lados.
//
// As variações seguem a literatura de doador vivo (Michels para artéria; tipos de
// bifurcação para porta; classificação de confluência para via biliar), sempre
// abrindo pelo HABITUAL e seguindo pelas mais frequentes.

export const ENXERTO_DOADO = [
  "Lobo direito",
  "Lobo esquerdo",
  "Segmento lateral esquerdo (II-III)",
];

export const VARIACAO_ARTERIAL = [
  "Habitual — AHC do tronco celíaco (tipo I)",
  "AHE substituída, da gástrica esquerda (tipo II)",
  "AHD substituída, da mesentérica superior (tipo III)",
  "AHD e AHE substituídas (tipo IV)",
  "AHE acessória, da gástrica esquerda (tipo V)",
  "AHD acessória, da mesentérica superior (tipo VI)",
  "AHD e AHE acessórias (tipo VII)",
  "Substituída + acessória (tipo VIII)",
  "AHC da mesentérica superior (tipo IX)",
  "AHC da gástrica esquerda (tipo X)",
  "Outra",
];

export const VARIACAO_PORTAL = [
  "Habitual — bifurcação (tipo 1)",
  "Trifurcação (tipo 2)",
  "Ramo posterior direito como 1º ramo (tipo 3)",
  "Ramo anterior direito da porta esquerda (tipo 4)",
  "Outra",
];

export const VARIACAO_BILIAR = [
  "Habitual — confluência de ductos direito e esquerdo (tipo 1)",
  "Trifurcação (tipo 2)",
  "Ducto posterior direito no hepático esquerdo (tipo 3a)",
  "Ducto posterior direito no hepático comum (tipo 3b)",
  "Ducto acessório / aberrante",
  "Outra",
];

export const VEIAS_HEPATICAS = [
  "Habitual — sem tributária significativa",
  "Veia hepática inferior direita (VHID) significativa",
  "Veia acessória — outra",
  "Outra",
];

export const SIM_NAO = ["Sim", "Não"];

export const PARECER_PSICOSSOCIAL = [
  "Apto",
  "Apto com ressalvas",
  "Inapto",
];

export const METODO_ESTEATOSE = [
  "Biópsia hepática",
  "RM (PDFF)",
  "Ultrassonografia",
  "Tomografia",
];

export const PARENTESCO_RECEPTOR = [
  "Cônjuge",
  "Pai/Mãe",
  "Filho(a)",
  "Irmão(ã)",
  "Avô/Avó",
  "Neto(a)",
  "Tio(a)",
  "Sobrinho(a)",
  "Primo(a) (4º grau)",
  "Sem parentesco",
];

export const AUTORIZACAO_JUDICIAL = [
  "Não se aplica (cônjuge ou parente até 4º grau)",
  "Necessária — pendente",
  "Necessária — obtida",
];

export const TIPO_SANGUINEO = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];

/** Converte uma lista de rótulos no formato de opções do catálogo da Pesquisa. */
export function comoOpcoesPesquisa(lista: string[]) {
  return lista.map((v) => ({ valor: v, label: v }));
}
